import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "../assets/css/mobile.css";

const Mobile = () => {
  return (
    <Container>
      <div className="page-content contact pt-3">
        <Row className="align-items-center">
          {/* Sol Kolon - Promosyon Görseli */}
          <Col lg={3} md={12} className="mb-4">
      
          <img src={require("../assets/mobile-left.jpeg")} style={{width: "100%", height: "100%"}} alt="Mobil Uygulamamız" />
          </Col>

          {/* Sağ Kolon - Açıklama Metni ve QR Kodlar */}
          <Col lg={9} md={12}>
            <div className="mobile-description">
              <div className="description-text">
                <p>
                Kurumumuzun yüz akı projelerinden olan Atatürk Ansiklopedisi’nin mobil uygulaması hayata geçti.
                </p><p> Uygulama, kullanım kolaylığı sağlamak adına koyu/açık mod seçenekleri, metin boyutu düzenleme,
                 maddeleri ‘Favoriler’e ekleme, daha önce ziyaret edilen maddeleri ‘Geçmiş’ sekmesinde görüntüleme, hızlı madde paylaşımı sağlama özellikleri ile Appstore ve Playstore’dan indirilebilmektedir. 
             </p>
          
                <p>
                  Tanıtım videosuna <a href="https://www.youtube.com/watch?v=Z3k3pIDGxvE" target="_blank" className="video-link">buradan</a> erişim sağlayabilirsiniz.
                </p>
              </div>
              
              <div className="url-section">
                <h5>URL adresleri:</h5>
                <p><strong>iOS için:</strong> <a href="https://apps.apple.com/ca/app/atat%C3%BCrk-ansiklopedisi/id6504850267" target="_blank" rel="noopener noreferrer">https://apps.apple.com/ca/app/atat%C3%BCrk-ansiklopedisi/id6504850267</a></p>
                <p><strong>Android için:</strong> <a href="https://play.google.com/store/apps/details?id=com.ayk.ataturkansiklopedisi" target="_blank" rel="noopener noreferrer">https://play.google.com/store/apps/details?id=com.ayk.ataturkansiklopedisi</a></p>
              </div>
              
              <div className="qr-codes">
                <div className="qr-code-item">
                  <div className="qr-code">
                    <img src={require("../assets/android.jpeg")} alt="Android QR Code" />
                  </div>
                  <h6 className="qr-title">Play Store</h6>
                </div>
                <div className="qr-code-item">
                  <div className="qr-code">
                    <img src={require("../assets/ios.jpeg")} alt="Apple QR Code" />
                  </div>
                  <h6 className="qr-title">Apple Store</h6>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      
      </div>
    </Container>
  );
};

export default Mobile;
